import _ from 'lodash';
import { FETCH_FOLLOWERS_SUCCESS } from '../../actions/fetch-followers';
import { CLEAR_FOLLOWERS } from '../../actions/clear-followers';

export default function followersIdListReducer(state = [], action) {
  switch (action.type) {
    case FETCH_FOLLOWERS_SUCCESS:
      return [...state, ..._.map(action.payload.followers, follower => follower._id)];
    case CLEAR_FOLLOWERS:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/followers/id-list.js